<template>
  <v-container>
    <v-row>
      <v-col md="8" lg="8" sm="11" cols="12" v-bind:style="windowWidth>600?'text-align: -webkit-right':''">
        <v-img
            v-if="windowWidth>600"
            class="shrink mr-2"
            src="~@/assets/images/Group87 (1).svg"
            style="margin-top:30px;height: 250px;width: 289px; margin-right: 20% !important;"
        >

        </v-img>
        <div>
          <img :src="$route.query.url" v-bind:class="windowWidth>600?'image1':'imageM'">
        </div>

      </v-col>
      <v-col md="4" lg="4" sm="11" cols="12" v-bind:style="windowWidth>600? 'text-align: -webkit-right':''  ">
        <v-img
            v-if="windowWidth>600"
            class="shrink mr-2"
            src="~@/assets/images/Group183.svg"
            style="margin-top:30px;height: 250px;width: 289px; margin-right: -4% !important;"
        >
        </v-img>

        <div v-bind:class="windowWidth>600?'image2':'image2M'">
          <div class="telegraficoFont" style=" text-transform: uppercase;font-size: 30px; margin-top:40px;">
            {{ $route.query.name }}
          </div>
          <div class="detailsContent" v-bind:style="windowWidth>600?'max-width: 70%; margin-top: 25px':''">
            {{ $route.query.description }}
          </div>
          <div class="price" :style="windowWidth<600?'font-size:1.4rem':''">
            {{ $route.query.price }} $
          </div>
          <div v-bind:class="windowWidth>600?'btnC':'btnM'"
               v-on:click="router.push({path:'confirmPurchase',query:{id: $route.query.id}})">
            <v-btn height="25px" width="120"
                   style="background-color: #FFFFFF!important;"
                   v-bind:class="windowWidth>600?'btnC1':'btnM1'"
            >
              Purchase
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from "@/router";

export default {
  name: "purchase",
  props: ['url', 'details', 'price'],
  data() {
    return {
      windowWidth: window.innerWidth,
      router
    }
  }
}
</script>

<style scoped>
.image2 {
  text-align: initial;
  position: absolute;
  top: 15%;
  left: 64%;
  width: 50%;
}

::v-deep .theme--dark.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: whitesmoke;
  border-radius: 10px;
}

.fieldH {
  height: 65px !important;
}

::v-deep .v-label {
  font-size: 12px;
}

.image1 {
  width: 37%;
  height: 65%;
  position: absolute;
  left: 13%;
  top: 8%;
}

.imageM {
  width: 100%
}

.image2M {
  text-align: center;
}

.btnC {
  text-align: start !important;
  margin-top: 20px !important;
}

.btnM {
  text-align: center !important;
  margin-top: 20px !important;
}

.btnM1 {
  border-radius: 5px !important;
  background-color: #FFFFFF !important;
  color: black !important;
  margin-bottom: 20px;
}

.btnC1 {
  margin-left: 20% !important;
  border-radius: 5px !important;
  background-color: #FFFFFF !important;
  color: black !important;
}

.detailsContent {
  text-transform: capitalize;
}

.price {
  font-size: 2rem;
  font-weight: bold;
  padding-bottom: 5px
}
</style>
